import React from "react";
import useAuthenticationStore, { AuthenticationViews, } from "./Store";
import { useConfiguration } from "./Configuration";
import ExternalLogin from "./ExternalLogin";

const ExternalLoginContainer: React.FC = () => {
  const { state, loginExternal } = useAuthenticationStore()
  const { configuration } = useConfiguration()

  return (
    <ExternalLogin
      reloginState={configuration.reloginState}
      lastLoginLink={configuration.lastLoginLink}
      isLoading={state.isLoading}
      loginExternal={loginExternal}
      subActionLink={"../" + AuthenticationViews.login}
    />
  )
}

export default ExternalLoginContainer